import type { CatalogTree } from '../types';

// The shell around every signed-in screen: the banners (merchant screens §4.1, §4.3, §4.4), the role state of an
// onboarding Merchant's Staff (§3.1) and the unknown-path state.
export const shell = {
  banners: {
    offline: 'Çevrimdışısınız. Bağlantı gelince devam eder.',
    polling: 'Canlı güncellemeler kesildi; her 30 saniyede yenileniyor.',
    resynced: 'Güncellendi',
    pastDue: 'Abonelik ödemeniz alınamadı. Kartınızı kontrol edin.',
    suspended: 'Aboneliğiniz askıda: asistan yanıt vermiyor. Ödeme yapınca yeniden başlar.',
    trialEnding: 'Deneme süreniz {date} tarihinde bitiyor.',
    pausedAll: 'Asistan tüm kanallarda duraklatıldı.',
    clockSkew: 'Cihaz saatiniz sunucuyla uyuşmuyor; süreler yanlış görünebilir.',
    billingAction: 'Plan ve ödeme',
    pausedAllAction: 'Asistan durumu',
  },
  onboardingStaff: 'Kurulumu işletme sahibi tamamlamalı.',
  // The service worker's notification for a push it cannot read (UI architecture §12: it always shows one).
  push: {
    genericTitle: 'Yeni bildirim',
    genericBody: 'Ayrıntılar için paneli açın.',
  },
  notFound: {
    message: 'Böyle bir sayfa yok.',
    back: 'Ana sayfaya dön',
  },
} as const satisfies CatalogTree;
